import {post, get} from './lib/ajax';
import {apiRoutes} from './globals';

export const actualTrucks = ({dom, date}) => (
    get(apiRoutes.ACTUAL_TRUCKS({dom, date}))
);

export const actualLeadTime = ({dom, dayOfWeek}) => (
    get(apiRoutes.ACTUAL_LEAD_TIME({dom, dayOfWeek}))
);

export const actualOccupancy = ({dom, date}) => (
    get(apiRoutes.ACTUAL_OCCUPANCY({dom, date}))
);

export const averageLeadTime = ({dom, dayOfWeek}) => (
    get(apiRoutes.AVERAGE_LEAD_TIME({dom, dayOfWeek}))
);

export const railStatusImport = ({dom}) => (
    get(apiRoutes.RAIL_STATUS_IN({dom}))
);

export const railStatusExport = ({dom}) => (
    get(apiRoutes.RAIL_STATUS_OUT({dom}))
);